import Container from "@src/components/_shared/Container";
import BlockTitle from "@src/components/_shared/UI/BlockTitle";
import Subtitle from "@src/components/_shared/UI/Subtitle";
import Contract from '@src/assets/Contract.png';
import Confetti from 'react-confetti-boom';

export default function Finish() {
    const colorA = getComputedStyle(document.documentElement).getPropertyValue('--color-a');
    const colorC = getComputedStyle(document.documentElement).getPropertyValue('--color-c');

    return (
        <Container>
            <div style={{margin: '40px auto', width: '50px', border: '2px solid var(--color-a)', borderRadius: '10px'}} />
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <img src={Contract} alt="Finish" width={268} height={249} />
            </div>
            <BlockTitle title="Félicitations !<br/>Vous avez signé votre contrat" />
            <Subtitle content="Votre demande a bien été prise en compte. Vous recevrez prochainement un e-mail avec les prochaines étapes et les informations utiles concernant votre compte." />
            <Confetti mode="boom" spreadDeg={35} y={0.55} launchSpeed={2} particleCount={200} colors={[colorA, colorC]}  />
        </Container>
    )
}
